import React from 'react';
import { Button } from './ui/button';
import { Heart, ArrowDown, Users, Shield, HeartHandshake } from 'lucide-react';
import { siteData } from '../data/mock';

const HeroSection = () => {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src={siteData.images.hero}
          alt="Jamaica community"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-stone-900/95 via-stone-900/80 to-stone-900/60" />
        <div className="absolute inset-0 bg-gradient-to-t from-stone-900/50 via-transparent to-transparent" />
      </div>

      {/* Decorative Elements */}
      <div className="absolute top-20 right-10 w-72 h-72 bg-emerald-500/10 rounded-full blur-3xl" />
      <div className="absolute bottom-20 left-10 w-96 h-96 bg-amber-500/10 rounded-full blur-3xl" />

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-3xl">
          {/* Badge */}
          <div className="inline-flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8">
            <span className="flex h-2 w-2 relative">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
            </span>
            <span className="text-white/90 text-sm font-medium">Humanitarian Initiative 2010-2030</span>
          </div>

          {/* Headline */}
          <h1 className="text-5xl sm:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
            {siteData.heroHeadline}
            <span className="block text-amber-400 mt-2">For A Better Future</span>
          </h1>

          {/* Subheadline */}
          <p className="text-xl text-white/80 mb-10 leading-relaxed max-w-2xl">
            {siteData.heroSubheadline}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Button
              asChild
              size="lg"
              className="bg-amber-500 hover:bg-amber-400 text-stone-900 font-bold text-lg px-8 py-6 shadow-2xl shadow-amber-500/30 hover:shadow-amber-400/40 transition-all hover:scale-105"
            >
              <a href={siteData.donateUrl} target="_blank" rel="noopener noreferrer">
                <Heart className="w-5 h-5 mr-2" />
                Donate Now
              </a>
            </Button>
            <Button
              asChild
              variant="outline"
              size="lg"
              className="border-2 border-white/30 bg-white/5 backdrop-blur-sm text-white hover:bg-white/10 hover:border-white/50 font-semibold text-lg px-8 py-6 transition-all"
            >
              <a href="#why-it-matters">
                Learn More
                <ArrowDown className="w-5 h-5 ml-2" />
              </a>
            </Button>
          </div>

          {/* Trust Indicators */}
          <div className="flex flex-wrap gap-8">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-emerald-500/20 flex items-center justify-center">
                <Users className="w-6 h-6 text-emerald-400" />
              </div>
              <div>
                <p className="text-white font-semibold">1000+</p>
                <p className="text-white/60 text-sm">Workers Supported</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-amber-500/20 flex items-center justify-center">
                <Shield className="w-6 h-6 text-amber-400" />
              </div>
              <div>
                <p className="text-white font-semibold">100%</p>
                <p className="text-white/60 text-sm">Transparent</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 rounded-full bg-emerald-500/20 flex items-center justify-center">
                <HeartHandshake className="w-6 h-6 text-emerald-400" />
              </div>
              <div>
                <p className="text-white font-semibold">Community</p>
                <p className="text-white/60 text-sm">Driven Initiative</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 animate-bounce">
        <a href="#why-it-matters" className="text-white/60 hover:text-white transition-colors">
          <ArrowDown className="w-6 h-6" />
        </a>
      </div>
    </section>
  );
};

export default HeroSection;
